// extracted by mini-css-extract-plugin
export default {"root":"src_root__+meUV","banner":"src_banner__9LbqH","ant-alert-content":"ant-alert-content","antAlertContent":"ant-alert-content"};